import React from "react";
import SubNav from "../../navbar/subNav";
import "./report.css";
import { useNavigate } from "react-router-dom";
import {currentProfile} from "../../../components/CommonSection/Cookie/Session";


const Reports = () => {

        const navigate = useNavigate();
    
        const reportData = [
            // {
            //   category: "Property Reports",
            //   icon: "🏠",
            //   reports: [
            //     "Bond Report",
            //     "Bond Report - Current Active Tenants Only",
            //     "Compliance by Property",
            //     "Compliance Status",
            //     "Inspections",
            //     "Inspections - Active",
            //     "Inspections - Properties Due",
            //     "Jobs",
            //     "Jobs - Sorted by Property",
            //     "Jobs - Sorted by Supplier (inc unassigned Jobs)",
            //     "Leases Expiring",
            //     "Onboarding - Fees by Owner",
            //   ],
            // },
            {
              category: "Contact Reports",
              icon: "👤",
              reports: [
                // "Client Access",
                // "Client Access - Owner Report",
                // "Client Access - Tenant Report",
                // "Contact Alerts",
                // "Contact Details",
                // "Contact Details - Owner",
                // "Contact Details - Supplier",
                // "Contact Details - Tenant",
                // "Onboarding - Owner Communication Method",
                "Owners without payment method",
                "Contact and their bank details"
              ],
            },
            {
              category: "Financial Reports",
              icon: "📄",
              reports: [
                // "Bills",
                // "Bills - Letting Fees",
                // "Disbursement Summary",
                // "Owner Income & Expense",
                // "Tenant Receipts",
                "Cash Book",
                "Folio Ledger",
                "Trial Report",
                "Outstanding Bills",
                "Outstanding Invoices"
              ],
            },
          ];
          
          const handleViewReport = (data) => {
            const encodedReport = encodeURIComponent(data);
            const currentSideBar = currentProfile.get();
            const path = currentSideBar === 2 ? "agency" : currentSideBar === 3 ? "agent" : null
            const url = `/${path}/report/viewReportsDetails?report=${encodedReport}`;
            window.open(url, '_blank'); // opens in a new tab
          };
          
  return (
      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 changedateantdstyle">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 daily-date-style">
              <div>
                  <SubNav title={"All Reports"} goback={false} extraData={true} />
                  <div className="material-work-desk-new bg-white m-3">
                      <div className="reports-wrapper">
                          {reportData.map((section, index) => (
                              <div key={index} className="report-section">
                                  <div className="section-header-report">
                                      <span className="section-icon-report">{section.icon}</span>
                                      {section.category}
                                  </div>
                                  <ul className="report-list">
                                      {section.reports.map((report, idx) => (
                                          <li key={idx} className="report-item" >
                                              <a href="#" onClick={(e) => { e.preventDefault(); handleViewReport(report); }}>
                                                  {report}
                                              </a>
                                          </li>
                                      ))}
                                  </ul>
                              </div>
                          ))}
                      </div>
                  </div>
              </div>
          </div>
      </div>
  );
};

export default Reports;
